import { render, staticRenderFns } from "./QuestionInput.vue?vue&type=template&id=38f938ff"
import script from "./QuestionInput.vue?vue&type=script&lang=ts"
export * from "./QuestionInput.vue?vue&type=script&lang=ts"
import style0 from "./QuestionInput.vue?vue&type=style&index=0&id=38f938ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
